import { Component, OnInit, HostListener, ElementRef,OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormValidationsService, QuoteDataCaptureService, LoaderService, SERVICE_END_POINT, AnalyticsService, CommonUtilityService, AuthService } from '../../../../shared';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../store/state/app.state';
import * as UserDataConfig from '../../config/user-data.config';
import { PersonalDetails } from '../../../../model/ngrx/personal-details.model';
import * as PersDetailsActions from '../../../../store/actions/personal-details.actions';
import { QuotePlaybackRiskWarning } from '../../../../model/ngrx/playback-risk-warnings.model';
import * as QuotePlaybackRiskWarningActions from '../../../../store/actions/playback-risk-warnings.actions';
import { UtilService } from '../../../../shared';
import { DependantDetails, RefNo } from 'src/app/model/ngrx';
import { AlertModal } from 'src/app/model/alert';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';

@Component({
  selector: 'app-quote-playback',
  templateUrl: './quote-playback.component.html',
  styleUrls: ['./quote-playback.component.scss']
})
export class QuotePlaybackComponent implements OnInit,OnDestroy {

  public contentData: any;
  public cmsDataProductChoice: any;
  public playbackList = [];
  public userInputDetail = UserDataConfig.ElementsConfig;
  public userForm: UntypedFormGroup;
  personDetail: PersonalDetails;
  public productsChoiceStore: Observable<any[]>;
  personalDetailsStore: Observable<PersonalDetails[]>;
  public productsChoice: {};
  protected selectedProduct: any;
  public selectedProductCode: string;
  quotePlaybackRiskWarningStore: Observable<QuotePlaybackRiskWarning[]>;
  riskQuestionaryForm: QuotePlaybackRiskWarning;
  riskQuestionForm: UntypedFormGroup;
  public getQuoteFlag: boolean;
  private subscriptn: Subscription;
  private subscripBeforeLogin: Subscription;
  private subscripSaveProgress: Subscription;
  dependentDetail: DependantDetails;
  dependentDetailStore: Observable<DependantDetails[]>;
  private subscripLogout: Subscription;
  loginDetail: any;
  displayAlert: boolean;
  protected alertLoginModalConfig: AlertModal;
  saveAlertWithoutLogin : boolean = false;
  isLocked: Boolean = false;
  public lockedAlertModalConfig: AlertModal;
  referenceNumberStore: Observable<RefNo[]>;
  referenceNumber: RefNo;
  displayACEFlag = false;
  amsErrorFlag = false;
  aceAlertModal: AlertModal;
  cmsACE;
  public CMSData;
  screenName;
  public dontShowMsgAgain: boolean;
  public noWarningMSg: boolean;
  quickQuoteObjRes;
  public tooltipModalConfig: AlertModal;
  tooltipModal;
  displayTooltipAlert = false;
  constructor(private fb: UntypedFormBuilder, private activatedRoute: ActivatedRoute, private router: Router,
              private store: Store<AppState>, private quoteDataCaptureService: QuoteDataCaptureService,
              private loaderService: LoaderService, public el: ElementRef,
              private utilService: UtilService, private analyticsService: AnalyticsService, private authService: AuthService) {
    this.contentData = this.activatedRoute.snapshot.data.contentData.pleaseConfirmDetails;
    this.playbackList = this.activatedRoute.snapshot.data.contentData.pleaseConfirmDetails.playBack;
    this.cmsDataProductChoice = this.activatedRoute.snapshot.data.contentData.productChoice;
    this.lockedAlertModalConfig = this.activatedRoute.snapshot.data.contentData['modalConfigLocked'];
    this.personalDetailsStore = store.select(STORE_VAL.personal_details);
    this.cmsACE = this.activatedRoute.snapshot.data.contentData.aceModal;
    this.tooltipModal = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;
    //console.log('personal-store', this.personalDetailsStore);
    // this.personalDetailsStore = store.select('personalDetails');
    this.personalDetailsStore.subscribe((val) => {
      if (val.length > 0) {
        //console.log('call subscribe');
        this.personDetail = val[0];
      }
    });
    this.referenceNumberStore = store.select(STORE_VAL.ref_no);
    this.referenceNumberStore.subscribe((val) => {
      if (val.length > 0) {
        this.referenceNumber = val[0];
      } else {
        this.referenceNumber = null;
      }
    });
    // need to chck positioning of this store independent of its affecting 
    // to check whole process flow order whether quotecapture first or quoteplayback
    this.quotePlaybackRiskWarningStore = store.select(STORE_VAL.quote_playback_risk_warning);
    this.quotePlaybackRiskWarningStore.subscribe((val) => {
      if (val.length > 0) {
        this.riskQuestionaryForm = val[0];
      }
    });
    this.productsChoiceStore = store.select(STORE_VAL.quote_capture);
    this.productsChoiceStore.subscribe(res => {
      if (res.length > 0) {
        this.productsChoice = res[0];
      }
    });
    this.dependentDetailStore = this.store.select(STORE_VAL.dependant_details);
    this.dependentDetailStore.subscribe((val) => {
      if (val.length > 0) {
        this.dependentDetail = val[0];
      }
    });
    this.store.select(STORE_VAL.loggedin_detail).subscribe(res => {
      if (res.length > 0) {
        this.loginDetail = res[0];
      }
    });
    this.store.select(STORE_VAL.quote_calculation).subscribe(res => {
      if (res.length > 0) {
        this.quickQuoteObjRes = res[0];
      }
    });
  }

  ngOnInit() {
    // tslint:disable-next-line:no-string-literal
    this.alertLoginModalConfig = this.contentData['saveModalConfigAnonymousUser'];
    this.tooltipModalConfig = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;
    this.aceAlertModal = this.cmsACE.aceModalError;
    if (this.productsChoice) {
      this.selectedProduct = this.cmsDataProductChoice.products.find(p => p.productCode === this.productsChoice['product']).productName;
      this.selectedProductCode = this.cmsDataProductChoice.products.find(p => p.productCode === this.productsChoice['product']).productCode;
      // this.cmsDataProductChoice.products.find(p => p.productCode === this.productsChoice['product']).productName
      // this.cmsDataProductChoice.products.find(p => p.productCode === this.productsChoice['product']).productCode
      // "Fixed Term Retirement Plan";
      //  'H';
    }
    this.GetCMSDataServiceMapper();
    if (this.riskQuestionaryForm) {
      this.riskQuestionForm = this.fb.group({
        taxPayRisk: [this.riskQuestionaryForm.taxPayRisk, Validators.required],
        inflation: [this.riskQuestionaryForm.inflation, Validators.required],
        claimPensionRisk: [this.riskQuestionaryForm.claimPensionRisk, Validators.required],
        takeOutPensionRisk: [this.riskQuestionaryForm.takeOutPensionRisk, Validators.required],
        overAllReturnRisk: [this.riskQuestionaryForm.overAllReturnRisk]
      });
    } else {
      this.setRiskQuestionForm();
    }
    this.userFormData();

    this.subscripBeforeLogin = this.quoteDataCaptureService.subsVar = this.quoteDataCaptureService.invokeLoginFunction.subscribe(() => {
      this.saveAfterLogin();
    });
    this.subscripSaveProgress = this.quoteDataCaptureService.subsVar = this.quoteDataCaptureService.invokeSaveFunction.subscribe(() => {
      this.saveProgress();
    });
    this.subscripLogout = this.quoteDataCaptureService.subsVar = this.quoteDataCaptureService.invokeLogoutFunction.subscribe(() => {
      this.saveAfterLogout();
    });
    if (this.selectedProductCode === 'H' || this.selectedProductCode === 'G') {
      this.riskQuestionForm.get('overAllReturnRisk').setValidators([Validators.required]);
      this.riskQuestionForm.get('overAllReturnRisk').updateValueAndValidity();
    }
  }

  alertPrimaryBtnClick() {
    // this.quoteDataCaptureService.onSave();
    this.quoteDataCaptureService.onLoginClick();
  }

  alertSecondaryBtnClick() {
    this.quoteDataCaptureService.onSave();
    this.router.navigate(['/home/registration']);
  }

  closeModal() {
    this.saveAlertWithoutLogin = false;
    this.displayAlert = false;
    this.displayTooltipAlert = false;
  }

  saveFormValues() {
    this.store.dispatch(new PersDetailsActions.RemovePersonalDetails(0));
    this.store.dispatch(new PersDetailsActions.AddPersonalDetails(this.personDetail));
    this.store.dispatch(new QuotePlaybackRiskWarningActions.RemoveQuotePlaybackRiskWarning(0));
    // tslint:disable-next-line:max-line-length
    this.store.dispatch(new QuotePlaybackRiskWarningActions.AddQuotePlaybackRiskWarning({
      taxPayRisk: this.riskQuestionForm.controls.taxPayRisk.value,
      inflation: this.riskQuestionForm.controls.inflation.value,
      claimPensionRisk: this.riskQuestionForm.controls.claimPensionRisk.value,
      takeOutPensionRisk: this.riskQuestionForm.controls.takeOutPensionRisk.value,
      overAllReturnRisk: this.riskQuestionForm.controls.overAllReturnRisk.value,
      riskAndStaticQuestion: this.createQuestionarray()
    }));
  }

saveProgress() {
  this.saveFormValues();
  this.quoteDataCaptureService.postQuoteDataCapture(false).subscribe();
 }

  saveAfterLogin() {
    this.saveFormValues();
    this.quoteDataCaptureService.postQuoteDataCapture(false).subscribe(res =>
    this.utilService.afterSaveSuccesfully());
 }

 saveAfterLogout() {
  this.saveFormValues();
  this.quoteDataCaptureService.postQuoteDataCapture(false).subscribe(res => {
  this.authService.logout();
  });
}

  // tslint:disable-next-line:use-life-cycle-interface
  ngOnDestroy() {
    if (this.subscriptn) {
      this.subscriptn.unsubscribe();
    }
    if (this.subscripBeforeLogin) {
    this.subscripBeforeLogin.unsubscribe();
    }
    if (this.subscripSaveProgress) {
      this.subscripSaveProgress.unsubscribe();
     }
    if (this.subscripLogout) {
    this.subscripLogout.unsubscribe();
    }
  }

  userFormData = () => {
    this.userInputDetail.buttonConfig.label = 'Get your quote';
    if (this.personDetail && this.personDetail.consentIndicator) {
      this.userForm = this.fb.group({
        consent: [this.personDetail.consentIndicator],
        next: ['']
      });
    } else {
      if (this.productsChoice['product'] === 'C') {
        this.userForm = this.fb.group({
          consent: [null, Validators.required],
          next: ['']
        });
      } else {
        this.userForm = this.fb.group({
          consent: [null],
          next: ['']
        });
      }
    }
  }

  setRiskQuestionForm() {
    this.riskQuestionForm = this.fb.group({
      taxPayRisk: [null, Validators.required],
      inflation: [null, Validators.required],
      claimPensionRisk: [null, Validators.required],
      takeOutPensionRisk: [null, Validators.required],
      overAllReturnRisk: [null]
    });
  }

  createQuestionarray(): any {
    const questionArray = [];
    if (this.riskQuestionForm.controls.taxPayRisk.value) {
      questionArray.push({
        questionCode: 'taxPayRiskQuestion',
        // question: this.contentData['taxPayRiskQuestion'].questionStatement,
        questionType: this.contentData['taxPayRiskQuestion'].questionType,
        answer: this.riskQuestionForm.controls.taxPayRisk.value
      });
    }
    if (this.riskQuestionForm.controls.inflation.value) {
      questionArray.push({
        questionCode: 'inflationQuestion',
        // question: this.contentData['inflationRiskQuestion'].questionStatement,
        questionType: this.contentData['inflationRiskQuestion'].questionType,
        answer: this.riskQuestionForm.controls.inflation.value
      });
    }
    if (this.riskQuestionForm.controls.claimPensionRisk.value) {
      questionArray.push({
        questionCode: 'claimPensionRiskQuestion',
        // question: this.contentData['claimPensionRiskQuestion'].questionStatement,
        questionType: this.contentData['claimPensionRiskQuestion'].questionType,
        answer: this.riskQuestionForm.controls.claimPensionRisk.value
      });
    }
    if (this.riskQuestionForm.controls.takeOutPensionRisk.value) {
      questionArray.push({
        questionCode: 'takeOutPensionRiskQuestion',
        // question: this.contentData['takeOutPensionRiskQuestion'].questionStatement,
        questionType: this.contentData['takeOutPensionRiskQuestion'].questionType,
        answer: this.riskQuestionForm.controls.takeOutPensionRisk.value
      });
    }
    if (this.riskQuestionForm.controls.overAllReturnRisk.value) {
      questionArray.push({
        questionCode: this.selectedProductCode === 'H' ? 'overAllReturnRiskQuestion' : 'overAllReturnRiskQuestion' ,
        // tslint:disable-next-line: max-line-length
        questionType: this.selectedProductCode === 'H' ? this.contentData['overAllReturnRiskQuestion'].questionType : this.contentData['overAllReturnRiskQuestion'].questionType,
        answer: this.riskQuestionForm.controls.overAllReturnRisk.value
      });
    }

    return questionArray;
  }

  gotoNextPage = () => {
    this.amsErrorFlag = false;
    // this.router.navigate(['/home/youroptionsquestions']);
    if (this.userForm.valid && this.riskQuestionForm.valid) {
    if (this.loginDetail) {
      this.analyticsService.selectedProductsTrack({ name: this.selectedProductCode })
      this.loaderService.handleSpinnerFlag({ show: true, onlyBackgroundFlag: true, Message: '', opacity: .4 });
      this.getQuoteFlag = true;
      // this.personDetail.consentIndicator = this.userForm.controls['consent'].value;
      this.personDetail = {...this.personDetail , consentIndicator: this.userForm.controls['consent'].value};
      /* changes done by kamlesh */
      // this.riskQuestionaryForm.taxPayRisk = this.riskQuestionForm.controls['taxPayRisk'].value;
      // this.riskQuestionaryForm.inflation = this.riskQuestionForm.controls['inflation'].value;
      // this.riskQuestionaryForm.claimPensionRisk = this.riskQuestionForm.controls['claimPensionRisk'].value;
      // this.riskQuestionaryForm.takeOutPensionRisk = this.riskQuestionForm.controls['takeOutPensionRisk'].value;
      /* changes done by kamlesh */
      this.personDetail.consentDate = this.getSystemDate();
      this.store.dispatch(new PersDetailsActions.RemovePersonalDetails(0));
      this.store.dispatch(new PersDetailsActions.AddPersonalDetails(this.personDetail));
      this.store.dispatch(new QuotePlaybackRiskWarningActions.RemoveQuotePlaybackRiskWarning(0));
      // tslint:disable-next-line:max-line-length
      this.store.dispatch(new QuotePlaybackRiskWarningActions.AddQuotePlaybackRiskWarning({...this.riskQuestionForm.value, riskAndStaticQuestion: this.createQuestionarray()}));
      this.quoteDataCaptureService.postQuoteRequest().subscribe(res => {
        if (res.errorAceCode) {
          this.aceErrorNotification(res.errorAceCode);
      } else {
        this.triggerWBGetQuote(res);
        this.loaderService.handleSpinnerFlag({ show: false, onlyBackgroundFlag: false, Message: '', opacity: .4 });
        this.getQuoteFlag = false;
        if ( res.compQuote && res.compQuote.errorMessage) {
          this.amsErrorFlag = false;
		      this.router.navigate(['/quote/your-product-quote']);
        } else {
          this.amsErrorFlag = false;
          // history.pushState(null, null, location.href);
          this.router.navigate(['/quote/your-product-quote']);
        }
       }
      },
        errr => {
          this.loaderService.handleSpinnerFlag({ show: false, onlyBackgroundFlag: false, Message: '', opacity: .4 });
          this.getQuoteFlag = false;
        });
      } else {
        if(this.quickQuoteObjRes && this.quickQuoteObjRes.benefitVariants) {
          const benefitVariants = this.quickQuoteObjRes.benefitVariants.filter(val => val.selected);
  
          this.analyticsService.eventTrack({
            type: 'ButtonClick',
            name: 'Get your quote',
            pageID: this.utilService.getScreenNameFromURL(this.router.url),
            annuityTypeApply: benefitVariants[0].quoteBasisModel.paymentFrequency ? benefitVariants[0].quoteBasisModel.paymentFrequency : null,// frequency, // to do check with Matt
            annuityApply: benefitVariants[0].quickQuoteModel.annuitantPension ? benefitVariants[0].quickQuoteModel.annuitantPension : null,
            pensionPotApply: benefitVariants[0].benefitBasisModel[0].pensionFund ? benefitVariants[0].benefitBasisModel[0].pensionFund : null,
            incomeApply: CommonUtilityService.formatIncome(benefitVariants[0].quoteBasisModel.paymentFrequency, benefitVariants[0].quoteBasisModel.paymentAdvance),
            paymentPeriodApply: benefitVariants[0].benefitBasisModel[0].guaranteedTerm ? benefitVariants[0].benefitBasisModel[0].guaranteedTerm : null
          });
        }
        this.utilService.isQuoteLocked(this.referenceNumber ? this.referenceNumber?.quoteReferenceNumber : null).subscribe(
          res => {
            if (res) {
              this.isLocked = true;
            } else {
              this.isLocked = false;
              this.saveAlertWithoutLogin = true;
              this.displayAlert = true;
            }
          }
        );
      }
    } else {
      FormValidationsService.validateAllFormFields(this.riskQuestionForm, this.analyticsService);
      FormValidationsService.validateAllFormFields(this.userForm, this.analyticsService);
      setTimeout(() => {
        this.scrollInvalidForm();
      });
    }
  }

  scrollInvalidForm() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.form-validation-error');
    if (invalidElements.length > 0) {
      invalidElements[0].scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    }
  }

  getSystemDate = (): string => {
    const today = new Date();
    const dd = today.getDate();
    const mm = today.getMonth() + 1;
    let strDate = dd.toString();
    let strMonth = mm.toString();
    const yyyy = today.getFullYear();
    if (dd < 10) {
      strDate = '0' + dd.toString();
    }
    if (mm < 10) {
      strMonth = '0' + mm.toString();
    }
    const formattedDate = strDate + '/' + strMonth + '/' + yyyy;
    return formattedDate;
  }

  click() {
    this.personDetail = {...this.personDetail , consentIndicator: this.userForm.controls['consent'].value};
    this.personDetail.consentDate = this.getSystemDate();
    this.store.dispatch(new PersDetailsActions.RemovePersonalDetails(0));
    this.store.dispatch(new PersDetailsActions.AddPersonalDetails(this.personDetail));
    this.store.dispatch(new QuotePlaybackRiskWarningActions.RemoveQuotePlaybackRiskWarning(0));
    // tslint:disable-next-line:max-line-length
    this.store.dispatch(new QuotePlaybackRiskWarningActions.AddQuotePlaybackRiskWarning({...this.riskQuestionForm.value, riskAndStaticQuestion: this.createQuestionarray()}));
  }

  OnBackClick() {
    this.personDetail.consentIndicator = this.userForm.controls['consent'].value;
    this.personDetail.consentDate = this.getSystemDate();
    this.store.dispatch(new PersDetailsActions.RemovePersonalDetails(0));
    this.store.dispatch(new PersDetailsActions.AddPersonalDetails(this.personDetail));
    this.store.dispatch(new QuotePlaybackRiskWarningActions.RemoveQuotePlaybackRiskWarning(0));
    // tslint:disable-next-line:max-line-length
    this.store.dispatch(new QuotePlaybackRiskWarningActions.AddQuotePlaybackRiskWarning({...this.riskQuestionForm.value, riskAndStaticQuestion: this.createQuestionarray()}));
  }

  // toggleVisibility(){
  //   if(this.selectedProductCode==='H' && this.playbackList[1]==="personalDetails"){
  //     this.visibility=false;
  //   }
  // }

  getVisibility(list) {
    if (this.selectedProductCode === 'C') {
      return list.visibility[0];
    } else if (this.selectedProductCode === 'H') {
      return list.visibility[1];
    } else if (this.selectedProductCode === 'G') {
      return list.visibility[2];
    }
  }
  closeLockedModal() {
    this.isLocked = false;
  }
  alertErrorPrimaryBtnClick() {
    this.closeErrorModal();
    if (this.aceAlertModal.footerPrimaryBtnLabel === 'Retry') {
      this.gotoNextPage();
    }
  }
  closeErrorModal() {
    this.displayACEFlag = false;
    this.noWarningMSg = (this.dontShowMsgAgain === true ? true : false);
  }
  dontShowUPMsgAgain(val) {
    this.dontShowMsgAgain = val;
  }

   /** Code block for CMS */
   GetCMSDataServiceMapper() {
    //console.log('changed value = ', this.contentData.header);
    const URL = SERVICE_END_POINT.higherEnvironment.CMS_PleaseConfirmYourDetails;
    this.utilService.getCMSData(URL).subscribe(res => {
      //console.log('2 GetCMSDataService => ', res);
      this.CMSData = res;
      if (this.CMSData) {
        /** In the line below we are over-writing the contentData object values with CMSData object values */
        // this.contentData.personalDetail.header = this.CMSData.string_YourPersonalDetailsTitle;
        this.contentData.header = this.CMSData.string_PleaseConfirmYourDetailsTitle;
        this.contentData.introduction = this.CMSData.string_PleaseConfirmYourDetailsSubtitle;

        this.contentData.taxPayRiskQuestion.questionStatement = this.CMSData.string_TaxRiskQuestionWording_1;
        this.contentData.taxPayRiskQuestion.infoIconData.content =
        this.CMSData.string_TaxRiskInformationWording + this.CMSData.html_TaxAndRetirementLink;
        this.contentData.taxPayRiskQuestion.questionOptions.find(q => q['label'] === 'No').infoText =
          this.CMSData.string_TaxRiskWarningWording;
        this.contentData.taxPayRiskQuestion.questionOptions.find(q => q['label'] === 'Unsure').infoText =
          this.CMSData.string_TaxRiskWarningWording;

        this.contentData.inflationRiskQuestion.questionStatement = this.CMSData.string_CostLivingRiskQuestionWording;
        this.contentData.inflationRiskQuestion.questionOptions.find(q => q['label'] === 'No').infoText =
          this.CMSData.string_CostLivingRiskWarningWording;
        this.contentData.inflationRiskQuestion.questionOptions.find(q => q['label'] === 'Unsure').infoText = this.CMSData.string_CostLivingRiskWarningWording;
        this.contentData.inflationRiskQuestion.infoIconData.content = this.CMSData.string_CostLivingRiskInformationWording;

        this.contentData.claimPensionRiskQuestion.questionStatement = this.CMSData.string_BenefitsRiskQuestionWording;
        this.contentData.claimPensionRiskQuestion.questionOptions.find(q => q['label'] === 'No').infoText =
          this.CMSData.string_BenefitsRiskWarningWording + this.CMSData.html_GovBenefitsLink.replace('<a','<a class="a-color"');
        this.contentData.claimPensionRiskQuestion.questionOptions.find(q => q['label'] === 'Unsure').infoText =
          this.CMSData.string_BenefitsRiskWarningWording + this.CMSData.html_GovBenefitsLink.replace('<a', '<a class="a-color"');
        this.contentData.claimPensionRiskQuestion.infoIconData.content = this.CMSData.string_BenefitsRiskInformationWording + this.CMSData.html_GovBenefitsLink;

        this.contentData.takeOutPensionRiskQuestion.questionStatement = this.CMSData.string_LoansRiskQuestionWording;
        this.contentData.takeOutPensionRiskQuestion.questionOptions.find(q => q['label'] === 'No').infoText =
          this.CMSData.string_LoansRiskWarningWording;
        this.contentData.takeOutPensionRiskQuestion.questionOptions.find(q => q['label'] === 'Unsure').infoText =
          this.CMSData.string_LoansRiskWarningWording;
        this.contentData.takeOutPensionRiskQuestion.infoIconData.content =
          this.CMSData.html_LoansRiskInformationWording.replace('<a', '<a class="anchor-padding"');
         // + this.CMSData.string_MoneyAdviseServiceDirectoryLinkText;

        this.playbackList[0].title = this.CMSData.string_FirstLifePersonalDetailsTitle;
        this.playbackList[1].title = this.CMSData.string_DependantPersonalDetailsTitle;
        this.playbackList[2].title = this.CMSData.string_PensionSavingsDetailsTitle;
        this.playbackList[3].title = this.CMSData.string_ProductChoiceDetailsTitle;
        this.playbackList[4].title = this.CMSData.string_FirstLifeHealthLifestyleDetailsTitle;
        this.playbackList[5].title = this.CMSData.string_DependantsHealthLifestyleDetailsTitle;
        this.playbackList[6].title = this.CMSData.string_FirstLifeMedicalDetailsTitle;
        this.playbackList[7].title = this.CMSData.string_DependantsMedicalDetailsTitle;
        // this.contentData.corpInfo = this.CMSData.stringGroup_CorpTitle;
        // this.contentData.ftrpInfo = this.CMSData.stringGroup_FtrpTitle;

        this.contentData.overAllReturnRiskQuestion.questionStatement = this.CMSData.string_OverallReturnsRiskQuestion;
        
        if(this.selectedProductCode && this.selectedProductCode === 'H') {
          this.contentData.overAllReturnRiskQuestion.infoIconData.content = this.CMSData.string_OverallReturnsRiskFTRPInfoPoint;
          this.contentData.overAllReturnRiskQuestion.questionOptions.find(q => q['label'] === 'No').infoText =
            this.CMSData.string_OverallReturnsRiskFTRPWarning;
          this.contentData.overAllReturnRiskQuestion.questionOptions.find(q => q['label'] === 'Unsure').infoText =
            this.CMSData.string_OverallReturnsRiskFTRPWarning;
        }
        if(this.selectedProductCode && this.selectedProductCode === 'G') {
          this.contentData.overAllReturnRiskQuestion.infoIconData.content = this.CMSData.string_OverallReturnsRiskCORPInfoPoint;
          this.contentData.overAllReturnRiskQuestion.questionOptions.find(q => q['label'] === 'No').infoText =
            this.CMSData.string_OverallReturnsRiskCORPWarning;
          this.contentData.overAllReturnRiskQuestion.questionOptions.find(q => q['label'] === 'Unsure').infoText =
            this.CMSData.string_OverallReturnsRiskCORPWarning;
        }
        this.contentData.amsErrorQuestion = this.CMSData.string_NoAmsErrorMessage;
        this.contentData['consentQuestion'].questionStatement = this.CMSData.string_WOMQuestion;
        this.contentData['consentQuestion'].dependantQuestionStatement = this.CMSData.string_WOMQuestionJoint;
        this.userInputDetail.buttonConfig.label = this.CMSData.string_GetYourQuoteCTALabel;
        if (this.selectedProductCode && (this.selectedProductCode === 'C')) {
          // tslint:disable-next-line:max-line-length
          this.contentData['consentQuestion'].questionStatement = this.dependentDetail.dependantQuestion === 'Y' ? this.contentData['consentQuestion'].dependantQuestionStatement : this.contentData['consentQuestion'].questionStatement;
        }
      }
    });
  }
  /** End of code block for CMS */
  aceErrorNotification(errorACE: any) {
    if (errorACE === 'A') {
      this.aceAlertModal = this.cmsACE.aceModalError;
      this.displayACEFlag = true;
      this.loaderService.handleSpinnerFlag({ show: false, onlyBackgroundFlag: false, Message: '', opacity: .4 });
      this.getQuoteFlag = false;
    } else {
      this.aceAlertModal = this.cmsACE.alternateACEErrorModal;
      this.displayACEFlag = true;
      this.loaderService.handleSpinnerFlag({ show: false, onlyBackgroundFlag: false, Message: '', opacity: .4 });
      this.getQuoteFlag = false;
    }
  }
     /** For web tracking */
 getCurrentScreenURL() {
  this.screenName = this.utilService.getScreenNameFromURL(this.router.url);
  return this.screenName;
}
  riskTaxReceiver(val) {
    this.analyticsService.eventTrack({ type: 'Question', name: val, pageID: this.getCurrentScreenURL() });
  }
  riskInflationReceiver(val) {
    this.analyticsService.eventTrack({ type: 'Question', name: val, pageID: this.getCurrentScreenURL() });
  }
  riskLongTermCareReceiver(val) {
    this.analyticsService.eventTrack({ type: 'Question', name: val, pageID: this.getCurrentScreenURL() });
  }
  riskDebtMgmtReceiver(val) {
    this.analyticsService.eventTrack({ type: 'Question', name: val, pageID: this.getCurrentScreenURL() });
  }
  riskOverallReturnFTRPReceiver(val) {
    this.analyticsService.eventTrack({ type: 'Question', name: val, pageID: this.getCurrentScreenURL() });
  }
  riskOverallReturnCORPReceiver(val) {
    this.analyticsService.eventTrack({ type: 'Question', name: val, pageID: this.getCurrentScreenURL() });
  }
  consentReceiver(val) {
    this.analyticsService.eventTrack({ type: 'Question', name: val, pageID: this.getCurrentScreenURL() });
  }
  triggerWBGetQuote(res) {
    let newBenefitVariants = (res && res.benefitVariants && res.benefitVariants.length > 0) ? res.benefitVariants : [];
    newBenefitVariants = newBenefitVariants[newBenefitVariants.length - 1];
    const annuitantPension = 'QuoteValue = ' + this.quickQuoteObjRes.benefitVariants[0].quickQuoteModel.annuitantPension;
    let frequency;
    let policy;
    if (res.product === 'C') {
      frequency = this.userInputDetail.radioButtonFrequencyConfig.questionOptions.filter(item => item.code === res.paymentFrequency);
      frequency = frequency[0].label;
      policy = res.guaranteedTerm ? CommonUtilityService.formatGuarantedPaymentPeriod(res.guaranteedTerm) : null;
    } else if (res.product === 'H') {
      // tslint:disable-next-line:max-line-length
      frequency = this.userInputDetail.radioButtonFTRPFrequencyConfig.questionOptions.filter(item => item.code === res.paymentFrequency);
      frequency = frequency[0].label;
      policy = res.guaranteedTermIndicator === 'O' ?
        (res.guaranteedTerm ? CommonUtilityService.formatGuarantedPaymentPeriod(res.guaranteedTerm) : null) : null;
    } else if (res.product === 'G') {
      // tslint:disable-next-line:max-line-length
      frequency = this.userInputDetail.radioButtonCORPFrequencyConfig.questionOptions.filter(item => item.code === res.paymentFrequency);
      frequency = frequency[0].label;
      policy = null;
    }
    this.analyticsService.eventTrack({
        type: 'ButtonClick',
        name: 'Get your quote',
        pageID: this.getCurrentScreenURL(),
        annuityTypeApply: frequency, // to do check with Matt
        annuityApply: annuitantPension,
        pensionPotApply: res.pensionFund ? res.pensionFund : null,
        incomeApply: CommonUtilityService.formatIncome(res.paymentFrequency, res.paymentAdvance),
        paymentPeriodApply: policy
      });
  }

  displayTooltipMessage(data){
    this.tooltipModal.content = data.infoIconData.content.replace('<a', '<a class="moneyhelperTxt"');
    this.displayTooltipAlert = true;
  }

  alertTooltipPrimaryBtnClick() {
    this.closeModal();
  }
}
